
class PageSearch {
  private container: HTMLElement | null;
  private tablist?: HTMLElement;
  private tabs?: HTMLButtonElement[];
  private panels?: HTMLElement[];

  constructor() {
    this.container = document.querySelector('.page-search')

    if (!this.container)
      return
    this.tabs = Array.from(this.container.querySelectorAll('[role="tab"]'));
    this.panels = [];
    this.tabs.forEach(tab => {
      const panelId = tab.getAttribute('aria-controls');
      if (panelId) {
        const panel = document.getElementById(panelId);
        if (panel) this.panels?.push(panel);
      }
    });

    this._init();
  }

  _init() {
    this.tabs?.forEach(tab => {
      tab.addEventListener('click', (event) => {
        event.preventDefault()
        if (tab.getAttribute('aria-selected') !== 'true') {
          this.switchTab(tab);
        }
      });
    })
  }


  private switchTab(newTab: HTMLButtonElement): void {
    // 1. Désactiver tous les onglets et cacher tous les panneaux
    this.tabs?.forEach(tab => {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
    });
    this.panels?.forEach(panel => {
      panel.hidden = true;
    });

    // 2. Activer le nouvel onglet
    newTab.classList.add('active');
    newTab.setAttribute('aria-selected', 'true');

    // 3. Afficher le panneau correspondant
    const panelId = newTab.getAttribute('aria-controls');
    const newPanel = document.getElementById(panelId!);
    if (newPanel) {
      newPanel.hidden = false;
    }

    // 4. Mettre le focus sur le nouvel onglet pour l'accessibilité au clavier
    newTab.focus();
  }
}

export const pageSearch = new PageSearch();
